import produce from 'immer';

import {
	AUTHENTICATION_PENDING,
	AUTHENTICATION_FULFILLED,
	AUTHENTICATION_FAILED
} from '../constants/auth.actions';

const authReducer = produce(
	(draft, action) => {
		switch(action.type) {
			case (AUTHENTICATION_PENDING): {
				draft.loading = true;
				draft.error = false;
				draft.authDenied = false;
				break;
			}
			case (AUTHENTICATION_FULFILLED): {
				draft.loading = false;
				draft.authenticated = true;
				draft.authDenied = false;
				draft.authInfo = action.payload.info;
				break;
			}
			case (AUTHENTICATION_FAILED): {
				draft.loading = false;
				draft.authenticated = false;
				draft.authDenied = true;
				break;
			}
			default: {
				break;
			}
		}
	},
	{
		loading: false,
		authenticated: false,
		authInfo: null,
		authDenied: false
	}
);

export default authReducer;
